import React from 'react';
import FixedContainer from '../components/common/FixedContainer';
import Illustration from '../components/common/Illustration';
import ProgressBar from '../components/ProgressBar';
import LinkButton from '../components/buttons/LinkButton';
import ReactGA from 'react-ga';

const Basket = () => {
  ReactGA.event(
    {
      category: 'Basket',
      action: 'Finish configuration',
      transport: 'beacon',
    },
    ['tracker1', 'tracker2'],
  );
  return (
    <div className="container basket">
      <ProgressBar link="/summary" />
      <p className="basket__text">Produkty zostały dodane do koszyka.</p>
      <Illustration imgUrl={`${process.env.PUBLIC_URL}/img/svg-illustrations/basket.svg`} />
      <FixedContainer padding={true}>
        <LinkButton link="/" text="zacznij od nowa" color="white" />
        <LinkButton link="summary" text="wróć do edycji" color="white" />
        <LinkButton link={process.env.REACT_APP_BASKET_URL} text="przejdź do koszyka" />
      </FixedContainer>
    </div>
  );
};

export default Basket;
